import type { Challenge } from '@source/graphql/autogenerate/schemas';
import { useCallback, useEffect, useState } from 'react';
import CompanyWhatsappButton from './CompanyWhatsappButton';
import CompanyWhatsappModal from './CompanyWhatsappModal';
import useWindowDimensions from '@source/utils/useWindowDimensions';

type CompanyWhatsappProps = {
  challengeDetails: Challenge;
  customButtonStyle?: React.CSSProperties;
  isCheckoutAndCompletedParticipant?: boolean;
  isChallengeDetailPageMobileSubscribeButtonVisible?: boolean;
};

const CompanyWhatsapp: React.FC<CompanyWhatsappProps> = ({
  challengeDetails,
  customButtonStyle,
  isCheckoutAndCompletedParticipant,
  isChallengeDetailPageMobileSubscribeButtonVisible
}): JSX.Element => {
  const { width } = useWindowDimensions();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isChallengeDetailButtonVisible, setIsChallengeDetailButtonVisible] =
    useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const scrollHandler = useCallback(() => {
    if (window.scrollY > 650) {
      setIsChallengeDetailButtonVisible(true);
    }

    if (window.scrollY < 650) {
      setIsChallengeDetailButtonVisible(false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', scrollHandler);
  }, [scrollHandler]);

  return (
    <>
      {isModalOpen ? null : (
        <CompanyWhatsappButton
          customButtonStyle={{
            ...customButtonStyle,
            // adjusts the button for checkout "Continue" button visibility (S.FloatingButton at src/components/Checkout/Summary/index.tsx)
            ...(isCheckoutAndCompletedParticipant &&
              width < 900 && {
                bottom: '8rem'
              }),
            // adjusts the button for challengeDetail "Subscribe" button (src/components/ChallengeDetails/SubscribeCard/index.tsx)
            ...(isChallengeDetailPageMobileSubscribeButtonVisible &&
              isChallengeDetailButtonVisible &&
              width < 900 && {
                left: '1.6rem',
                bottom: '8.5rem'
              })
          }}
          customAction={handleOpenModal}
        />
      )}

      <CompanyWhatsappModal
        deviceWidth={width}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        challengeDetails={challengeDetails}
        customButtonStyle={customButtonStyle}
      />
    </>
  );
};

export default CompanyWhatsapp;
